import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.css'],
    standalone: false
})
export class PrivacyComponent implements OnInit {

  ngOnInit(): void {
    document.getElementsByTagName('mat-sidenav-content')[0]?.scrollTo(0, 0);
  }

}
